import useTranslations from "hooks/useTranslations"
import TwoTierPricing from "components/organisms/TwoTierPricing"

const Pricing = () => {
  const { orderSectionTitle } = useTranslations()
  return (
    <div>
      <TwoTierPricing
        tiers={[
          "pricingTierBaseOneCase",
          // "pricingTierBaseSubscription",
          // "pricingTierParentalOneCase",
          // "pricingTierParentalSubscription",
          "pricingTierInfluencerOneCase",
          // "pricingTierInfluencerSubscription",
        ]}
        title={orderSectionTitle}
      />
    </div>
  )
}

export default Pricing
